<template>
  <v-container>
    <v-card>
      <v-card-title>All Users</v-card-title>
      <v-data-table
          :headers="headers"
          :items="users"
          :search="search"
          :loading="$store.getters.isLoading1"
      >
        <template v-slot:top>
          <v-text-field
              v-model="search"
              label="Search User"
              style="width: 40%"
              class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:[`item.first_name`]="{ item }">
          {{ item.first_name }} {{ item.last_name }}
        </template>
        <template v-slot:[`item.last_logged_in`]="{ item }">
          {{ item.last_logged_in }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                  icon
                  v-on="on"
                  color="error"
                  @click="deleteUserModal(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <div>
              <p>Delete User</p>
            </div>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="delete_user_modal" width="400">
      <v-card v-if="delete_user_obj">
        <v-container>
          <v-card-title>Delete User</v-card-title>
          <v-card-text>
            Are you sure you want to delete this user <b>{{ delete_user_obj.first_name }} {{ delete_user_obj.last_name }}</b>?
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-spacer/>
              <v-btn>Cancel</v-btn>
              <v-btn class="pl-3" color="red" @click="deleteUser(delete_user_obj)">Delete User</v-btn>
            </v-row>
          </v-card-actions>
        </v-container>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  name: "TablesView",
  data() {
    return {
      delete_user_modal: false,
      search: '',
      new_table: {
        name: '',
        event_datetime: '',
        min_stake: 0,
        status: 'UPCOMING',
        players: [],
        waiting_list: [],
        created_by: this.$store.getters.user._id
      },
      delete_user_obj: null,
      edit_table: null,
      headers: [
        { text: 'Name', value: 'first_name'},
        { text: 'Username', value: 'user_name'},
        { text: 'Email', value: 'email'},
        { text: 'Points', value: 'reward_points.points'},
        { text: 'Status', value: 'status'},
        { text: 'Last logged In', value: 'last_logged_in'},
        { text: 'Actions', value: 'actions'},
      ]
    }
  },
  methods: {
    deleteUserModal(item) {
      this.delete_user_obj = null
      this.delete_user_obj = item
      this.delete_user_modal = !this.delete_user_modal
    },
    async deleteUser(item) {
      await this.$store.dispatch('DELETE_USER', { email: item.email })
      this.delete_user_modal = !this.delete_user_modal
    },
  },
  computed: {
    users() {
      return this.$store.getters.users
    },
    isLoading1() {
      return this.$store.getters.isLoading1
    }
  },
  watch: {
    users: function (v) { return v || [] },
    isLoading1(v) {
      return v
    }
  },
  created() {
    console.log(this.$store.getters.user)
    this.$store.dispatch('GET_USERS')
    this.$store.commit('setIsLoading1', false)
  }
}
</script>

<style scoped>

</style>